import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || '';

class SeoApi {
    async get(path) {
        const response = await axios.post(`${API_BASE_URL}/api/seo`, { path });

        return response.data;
    }
}

export default new SeoApi();
